import { Component, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { LoginComponent } from './auth/login/login.component';
import { Platform } from '@ionic/angular';
import { register } from 'swiper/element/bundle';

register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  constructor(
    private deeplinks: Deeplinks,
    private router: Router,
    private zone: NgZone,
    private platform: Platform
  ) {
    this.initDeeplinks();
    console.log(
      console.log('android', this.platform.is('android')),
      console.log(this.platform.is('capacitor')),
      console.log(this.platform.is('cordova')),
      console.log('desktop', this.platform.is('desktop')),
      console.log(this.platform.is('electron')),
      console.log(this.platform.is('hybrid')),
      console.log(this.platform.is('ios')),
      console.log('mobile', this.platform.is('mobile')),
      console.log('mobileweb', this.platform.is('mobileweb')),
      console.log(this.platform.is('phablet')),
      console.log(this.platform.is('pwa')),
      console.log('tablet', this.platform.is('tablet'))
    );
  }

  initDeeplinks() {
    this.deeplinks
      .route({
        '/login': LoginComponent,
      })
      .subscribe((match) => {
        // match.$route - the route we matched, which is the matched entry from the arguments to route()
        // match.$args - the args passed in the link
        // match.$link - the full link data
        // Run the navigation in the Angular zone
        this.zone.run(() => {
          this.router.navigate(['/login'], { queryParams: match.$args });
        });
      }); //, nomatch => {
    //   // nomatch.$link - the full link data
    //   console.error('Got a deeplink that didn\'t match', nomatch.$link);
    // });
  }
}
